<template>
  <v-col>
    <h2 class="capitalize subtitle-1">Models</h2>
    <v-card
        v-for="(item, m) in models"
        :key="m"
        class="pa-2"
        outlined
        tile
    >
      <h3 class="subtitle-2">{{ m }}</h3>
      <v-list
          v-for="(c, model) in count"
          :key="model"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <code>{{ item.first }}</code>
            </v-list-item-title>
            <v-list-item-subtitle>First item</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <code>{{ item.last }}</code>
            </v-list-item-title>
            <v-list-item-subtitle>Last item</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "model",
  props: {
    models: {
      required: true,
      type: Object,
    },
    count: {
      required: true,
      type: Object,
    },
  }
}
</script>
